export type Asset = {
  id: number;
};

export type AssetAmount = Asset & {
  amount: number;
};

export enum AssetFormat {
  FIAT = 'fiat',
  CRYPTO = 'crypto',
}

export enum OrderStatus {
  COMPLETED = 'Completed',
  CANCELED = 'Canceled',
  PENDING = 'Pending',
}

export enum OrderType {
  BUY = 'buy',
  SELL = 'sell',
}

export enum WalletKind {
  REGULAR = 'regular',
  PRE_FUNDED = 'preFunded',
}

export type AssetInfoType = Asset & {
  name: string;
  code: string;
  symbol: string;
  assetType: string;
  assetFormat: AssetFormat;
  upperLimit: number;
  lowerLimit: number;
  roundingAccuracy: number;
  imageUrl?: string;
  isStable: boolean;
};

export type AssetAmountInfoType = AssetInfoType & { amount: number };

export type AllAssetsResponse = {
  baseAsset: Asset;
  items: AssetInfoType[];
};

export type AllAssetsType = {
  [id in number]?: AssetInfoType;
};

export type PortfolioAssetResponse = {
  amount: number;
  rate: number;
  equivalent: number;
  todayDifferencePercent: number;
  estCostBasis: number;
  sinceFirstPurchaseAmount: number;
  sinceFirstPurchasePercent: number;
  asset: Asset;
  walletKind?: WalletKind;
};

export type PortfolioAssetType = Omit<PortfolioAssetResponse, 'asset'> & {
  asset: AssetInfoType;
};

export type PortfolioAssetsResponse = {
  items: PortfolioAssetResponse[];
  baseAsset: Asset;
};

export type PortfolioAssetsType = {
  items: PortfolioAssetType[];
  baseAsset: AssetInfoType;
};

export type PortfolioBalanceResponse = {
  asset: Asset;
  amount: number;
  todayBalanceDifference: number;
};

export type PortfolioTransactionsResponse = {
  items: PortfolioTransactionItemResponse[];
  limitOrders?: PortfolioTransactionItemResponse[];
};

export type PortfolioTransactionsType = {
  items: PortfolioTransactionItemType[];
  limitOrders?: number | PortfolioTransactionItemType[];
};

export type PortfolioTransactionItemResponse = {
  asset: AssetAmount;
  baseAsset: AssetAmount;
  orderTimestamp: string;
  orderType: OrderType;
  quotedPrice: number;
  orderNumber: string;
  orderStatus: OrderStatus;
  madeBy?: string;
  chargedFrom?: string;
  walletKind?: WalletKind;
};

export type PortfolioTransactionItemType = Omit<
  PortfolioTransactionItemResponse,
  'asset' | 'baseAsset'
> & {
  asset: AssetAmountInfoType;
  baseAsset: AssetAmountInfoType;
};

export type GenerateAccountStatementPayload = {
  userProfileId: number;
  startDate: string;
  endDate: string;
  timeZoneId: string;
};
